










import Vue, { PropType } from 'vue';
import { InputState } from '../../forms.types';
import { Icon } from '../../../../basic';

export default Vue.extend({
  name: 'InputWrapper',
  components: {Icon},
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String as PropType<'default' | 'small'>,
      default: 'default',
    },
    state: {
      type: String as PropType<InputState>,
      default: 'default',
    },
    hasIcon: {
      type: Boolean,
      default: false,
    },
    noLabel: {
      type: Boolean,
      default: false,
    },
    focused: Boolean,
  },
  data() {
    return {
      myFocused: false,
    };
  },
  computed: {
    showIcon(): boolean {
      return !this.hasIcon &&
        !this.focused &&
        !this.myFocused &&
        (this.state === 'success' || this.state === 'error');
    },
  },
});
